import { SessionHelper } from "app/helpers/sessionHelper";
import { FormattedMessage } from "react-intl";
import "./PlayerPropsSubHeading.scss";

type Props = {
  player: string;
  over: string;
  under: string;
};

const PlayerPropsSubHeading = ({ market, player, over, under }: Props) => {
  return (
    <div
      className={`player-props subheading ${
        SessionHelper.isAsianRouteAndSessionView() ? "asian" : "euro"
      }`}
    >
      <div className="header">
        <div className="subheading-player">
          <FormattedMessage tagName="span" id="playerprops-subheader-player" />
        </div>
        <div className="subheading-over">
          <FormattedMessage tagName="span" id="playerprops-subheader-over" />
        </div>
        <div className="subheading-under">
          <FormattedMessage tagName="span" id="playerprops-subheader-under" />
        </div>
      </div>
    </div>
  );
};

export default PlayerPropsSubHeading;
